import { CLOSE_SUB_MODAL, OPEN_SUB_MODAL } from "src/store/constants/onlineShopper";
import { SubModalType } from "Types/state";

export interface OpenSubModalAction {
    data: {
        message?: string;
        modalType: SubModalType;
        refresh?: boolean;
        title?: string;
        statusCode?: number;
        vin?: string;
        bankOfferIndex?: number;
    };
    type: OPEN_SUB_MODAL;
}

type OpenSubModal = (data: {
    modalType: SubModalType;
    title?: string;
    message?: string;
    refresh?: boolean;
    statusCode?: number;
    vin?: string;
    bankOfferIndex?: number;
}) => OpenSubModalAction;

export const openSubModal: OpenSubModal = (data) => {
    return {
        data,
        type: OPEN_SUB_MODAL,
    };
};

export interface CloseSubModalAction {
    type: CLOSE_SUB_MODAL;
}

export function closeSubModal(): CloseSubModalAction {
    return {
        type: CLOSE_SUB_MODAL,
    };
}
